require('./brokerTestConvenienceConfirmation.scss');

// @vendors
const React = require("react");
const PropTypes = require("prop-types");

// @commons
const { OKLink } = require("commonsComponents/OKLink");
const FormattedTextWithComponents = require("components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents");
const { OKMessage } = require('commonsComponents/OKMessage');

// @components
const BrokerConvenienceTestResult = require("./brokerConvenienceTestResult/brokerConvenienceTestResult");
const BrokerOtpConfirmation = require("./brokerOtpConfirmation/brokerOtpConfirmation");
const { LoadingSection } = require('commonsComponents/loadingSection');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

// @utilities
const { FormattedText } = require("core/i18n").i18n;
const PersonalDataHelper = require('utilities/personalDataHelper');
const { isPrivateEquityTest } = require('mifid/utilities/mifidPrivateEquityHelper');


// @constants

class BrokerConvenienceTestConfirmation extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { flagBasedFeatures, immBrokerConvenienceMiFIDTest, history } = this.props;
        const checkLessScoreFF = flagBasedFeatures.get('convenience_test_less_score_warning');
        const hasRoboPortfolio = immBrokerConvenienceMiFIDTest.get('hasRoboPortfolio');
        const continueWithDisapproved = immBrokerConvenienceMiFIDTest.get('continueWithDisapproved');
        if (checkLessScoreFF && hasRoboPortfolio && !continueWithDisapproved) {
            this.props.getCurrentTestScore(history);
        }

        const customData = {
            nombrePagina: "tu-inviertes/test-mifid",
            tipoProceso: "proc-tu-inviertes-test-mifid",
            pasoProceso: "confirmacion"
        }

        window &&
            window.utag &&
            window.utag.view &&
            window.utag.view(customData);
    }

    buildMandatoryDissaprovedScriptCC() {
        const { immBrokerConvenienceMiFIDTest, immProfileFields } = this.props;
        const clientName = <span>{PersonalDataHelper.getFullName(immProfileFields, false)}</span>;
        const continueWithDisapproved = immBrokerConvenienceMiFIDTest.get('continueWithDisapproved')
        return __CONTACT_CENTER__ && continueWithDisapproved
            ? (
                <div className="broker-convenience-test-confirmation__dissaproved-script-container">
                    <div className="broker-convenience-test-confirmation__dissaproved-script-title">
                        <FormattedText value="broker-convenienceMifidDisapprovedCCScriptTitle" />
                    </div>
                    <BlockInfo>
                        <p>
                            <FormattedTextWithComponents value="broker-convenienceMifidDisapprovedCCScriptContent1"/>
                        </p>
                        <p>
                            <FormattedTextWithComponents
                                value="broker-convenienceMifidDisapprovedCCScriptContent2"
                                injectedComponents={[
                                    clientName
                                ]}
                            />
                        </p>
                    </BlockInfo>
                </div>
            ) : null
    }

    render() {
        const { immBrokerConvenienceMiFIDTest, flagBasedFeatures } = this.props;
        const loadingTestResult = immBrokerConvenienceMiFIDTest.get('loadingCurrentTest');
        const fetchedCurrentTest  = immBrokerConvenienceMiFIDTest.get('fetchedCurrentTest');
        const testToEvaluateId = immBrokerConvenienceMiFIDTest.getIn(['mifidv2','testToEvaluate', 'tipoTest'])
        const checkLessScoreFF = flagBasedFeatures.get('convenience_test_less_score_warning');
        const hasRoboPortfolio = immBrokerConvenienceMiFIDTest.get('hasRoboPortfolio');
        const continueWithDisapproved = immBrokerConvenienceMiFIDTest.get('continueWithDisapproved');
        if (loadingTestResult) {
            return <LoadingSection />;
        }
        const linkElement = (
            <OKLink
                className="broker-convenience-test-confirmation__revise-link"
                modifier="emphasize"
                onClick={this.props.goToFirstStep}
            >
                <FormattedText value="raSuitabilityTestSuccess-raSuitabilityTestSuccess_reviseLink" />
            </OKLink>
        );

        const confirmacionContent =
            isPrivateEquityTest(testToEvaluateId) ? (
                <React.Fragment>
                    <div className="broker-convenience-test-confirmation__header">
                        <div className="broker-convenience-test-confirmation__header-title">
                            <FormattedText value="broker-convenienveMifidAltFundTestConfirmationTitle" />
                        </div>
                        <div className="broker-convenience-test-confirmation__header-description">
                            <FormattedText value="broker-convenienveMifidAltFundTestConfirmationDescription" />
                        </div>
                        <div className="broker-convenience-test-confirmation__header-separator"/>
                        <div className="broker-convenience-test-confirmation__revise-link">
                            <FormattedTextWithComponents
                                value="raSuitabilityTestSuccess-raSuitabilityTestSuccess_reviseText"
                                injectedComponents={[linkElement]}
                            />
                        </div>
                    </div>
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <BrokerConvenienceTestResult
                        alwaysShowSeparator
                        productDescription={"secondParagraph"}
                        lastResultInvestorLabel={"lastResultInvestorLabel"}
                        immBrokerConvenienceMiFIDTest={
                            this.props.immBrokerConvenienceMiFIDTest
                        }
                    />
                    <div className="broker-convenience-test-confirmation__revise-link">
                        <FormattedTextWithComponents
                            value="raSuitabilityTestSuccess-raSuitabilityTestSuccess_reviseText"
                            injectedComponents={[linkElement]}
                        />
                    </div>
                    {this.buildMandatoryDissaprovedScriptCC()}
                </React.Fragment>
            );

        const alternativeFundsTestDisclaimer = isPrivateEquityTest(testToEvaluateId) ? (
            <div className="broker-convenience-test-confirmation__alternative-funds-test-disclaimer">
                <OKMessage modifier="dark-bg" >
                    <FormattedText value="broker-convenienveMifidAltFundTestConfirmationFooterDisclaimer" />
                </OKMessage>
            </div>
        ) : null;

        return (
            <React.Fragment>
                <div className="broker-convenience-test-confirmation__top-disclaimer no-print-out">
                    <FormattedText value="broker-convenienveMifidTestConfirmationHeaderTitle" />
                </div>
                <div className="broker-convenience-test-confirmation__profile-section">
                    {confirmacionContent}
                    {((isPrivateEquityTest(testToEvaluateId) || (!loadingTestResult && fetchedCurrentTest)) ||
                        !(checkLessScoreFF && hasRoboPortfolio && !continueWithDisapproved)) &&
                        <BrokerOtpConfirmation
                            immBrokerConvenienceMiFIDTest={
                                this.props.immBrokerConvenienceMiFIDTest
                            }
                            onTestResultsConfirm={this.props.onTestResultsConfirm}
                        />
                    }
                </div>
                {alternativeFundsTestDisclaimer}
            </React.Fragment>
        );
    }
}

BrokerConvenienceTestConfirmation.propTypes = {
    onTestResultsConfirm: PropTypes.func,
    goToFirstStep: PropTypes.func,
    immBrokerConvenienceMiFIDTest: PropTypes.object,
    immProfileFields: PropTypes.object,
    flagBasedFeatures: PropTypes.object,
    history: PropTypes.object,
    getCurrentTestScore: PropTypes.func,
};

module.exports = BrokerConvenienceTestConfirmation;
